import { z } from "zod";

export const patSchema = z
  .string()
  .trim()
  .regex(/^(github_pat_|ghp_)[A-Za-z0-9_]+$/, "Not a valid GitHub PAT format")
  .min(40, "Token too short — did you paste the whole value?");
